import { TemplateType } from 'constants/templateTypes';
import {
  ModalType,
  useCampaignContext,
  useFeatureFlagContext,
  useModalContext,
  useTemplateContext,
} from 'modules/campaigns/editor/context';
import { getIsWhatsAppCampaign } from 'modules/campaigns/lib/utils';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { Send } from 'ui/icons';
import { CampaignPopover } from '../../../CampaignPopover';
import { CampaignPermissionCheck } from '../../CampaignPermissionCheck';

export const ActivateCampaignAction = () => {
  const { isSuspendSendsEnabled } = useFeatureFlagContext();
  const { openModal } = useModalContext();
  const { campaign } = useCampaignContext();
  const { templateAndContent } = useTemplateContext();

  const isWhatsApp = getIsWhatsAppCampaign(campaign.messageMedium);
  const isUserInitiatedType = templateAndContent.templateType === TemplateType.UserInitiated;

  const handleClick = () => {
    openModal(ModalType.ActivateCampaignModal, { isWhatsApp, isUserInitiatedType });
  };

  return (
    <CampaignPermissionCheck action="activate" ChildWrapper={CampaignPopover}>
      <PrimaryButton
        isDisabled={isSuspendSendsEnabled}
        data-test="activate-button"
        size={BUTTON_SIZES.LARGE}
        onClick={handleClick}
      >
        <Send height={20} />
        Activate
      </PrimaryButton>
    </CampaignPermissionCheck>
  );
};
